import _axios from "./cmsBase";
import { getLocale } from "../utils/i18n";

class LegalService {
  async getPrivacyPolicy() {
    return _axios.get(`privacy-policy?locale=${getLocale()}`);
  }

  async getTermsOfUse() {
    return _axios.get(`terms-of-use?locale=${getLocale()}`);
  }

  async getCookiesPolicy() {
    return _axios.get(`cookie?locale=${getLocale()}`);
  }

  async getTrackerPolicy() {
    return _axios.get(`consent-modals?populate=*&locale=${getLocale()}`);
  }
}

export default new LegalService();
